import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'antd';
import { 
  CodeOutlined, 
  FileTextOutlined, 
  PictureOutlined, 
  SoundOutlined, 
  VideoCameraOutlined,
  LinkOutlined
} from '@ant-design/icons';

const HeroSection = styled.section`
  background: linear-gradient(135deg, #1890ff 0%, #722ed1 100%);
  color: white;
  padding: 5rem 0;
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionContainer = styled.section`
  padding: 4rem 0;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: #1890ff;
    margin: 0.5rem auto;
  }
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  text-align: center;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: #1890ff;
  margin-bottom: 1rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 1rem;
`;

const FeatureDescription = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
`;

const Home: React.FC = () => {
  return (
    <>
      <HeroSection>
        <div className="container">
          <HeroTitle>谦言万语</HeroTitle>
          <HeroSubtitle>
            探索AI的无限可能，分享知识的力量
          </HeroSubtitle>
          <Button type="primary" size="large">
            <Link to="/about">了解更多</Link>
          </Button>
        </div>
      </HeroSection>
      
      <SectionContainer>
        <div className="container">
          <SectionTitle>主要内容</SectionTitle>
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <CodeOutlined />
                </IconWrapper>
                <FeatureTitle>AI编码</FeatureTitle>
                <FeatureDescription>
                  探索AI辅助编程的前沿技术与应用，提升开发效率
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/ai-coding">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <FileTextOutlined />
                </IconWrapper>
                <FeatureTitle>AI文字创作</FeatureTitle>
                <FeatureDescription>
                  利用AI生成高质量文本内容，辅助写作与创作
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/ai-creation">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <PictureOutlined />
                </IconWrapper>
                <FeatureTitle>AI图片生成</FeatureTitle>
                <FeatureDescription>
                  通过AI技术创造独特的视觉艺术作品
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/ai-creation">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <SoundOutlined />
                </IconWrapper>
                <FeatureTitle>AI语音合成</FeatureTitle>
                <FeatureDescription>
                  探索自然流畅的AI语音技术与应用
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/ai-creation">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <VideoCameraOutlined />
                </IconWrapper>
                <FeatureTitle>AI视频创作</FeatureTitle>
                <FeatureDescription>
                  使用AI技术辅助视频内容制作与编辑
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/ai-creation">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <FeatureCard>
                <IconWrapper>
                  <LinkOutlined />
                </IconWrapper>
                <FeatureTitle>知识链接</FeatureTitle>
                <FeatureDescription>
                  收集整理优质学习资源，分享知识图谱
                </FeatureDescription>
                <Button type="primary">
                  <Link to="/knowledge">查看详情</Link>
                </Button>
              </FeatureCard>
            </Col>
          </Row>
        </div>
      </SectionContainer>
    </>
  );
};

export default Home; 